import Vue from 'vue';

export default {
    getHistorico(parametros){
        return Vue.axios.get("historico_empleado/find", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    }
}